import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import Swal from 'sweetalert2';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConvenioService } from 'src/app/services/convenio/convenio.service';


export interface DialogData
{
    archivos: any
    idPostulacion: any
    montoSolicitado: any
    rutUsuario: any
    nombreUsuario: any
    apellidoUsuario: any    
    rol:any
    recarga:any
    cantidadCuota:any
    idCantidadCuota:any
    idCodeudor:any
    idCodeudor2:any
    idConvenio:any
    tipoConvenio:any
    montoCuota:any
    fechaPrimerPago:any
    deshabilitado:true
    nombreCorto:any
    region:any
    idCarga:any
    nombreCarga: any
    rutCarga:any
    editable: any
    numPresupuesto: any
    proveedor:any
    regiones: any
    idProveedor: any
    descripcionCantidadCuotas:any
    
}

@Component({
    selector: 'dialog-overview-prestamo-dialog',
    templateUrl: '../../pages/convenio/convenio-codeudor.html',
    styleUrls: ['../../pages/convenio/convenio.component.css']
})
export class DialogEditConvenio
{
    convenio: any = {montoSolicitado:'',cantidadCuotas:'0',idCantidadCuota:'',
            idUsuario: '',idAfiliado:'',idCodeudor1:'',
      idCodeudor2:'',tipoPrestamo:'seleccione',
      nombreSolicitante:'', apellidoSolicitante:'', 
      idPostulacion:'',idPrestamo:'',montoCuota:0,region:'0',
      archivos: []}
    cantidadArchivos: any = 2
    procesando: boolean = false
    regiones:any
    proveedor:any
    constructor( public dialogRef: MatDialogRef<DialogEditConvenio>,
        private convenioService: ConvenioService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog )
                 {
                    this.data = data;
                    console.log("this.data !!!!",this.data)

                  }

    ngOnInit(): void
         { this.loadData() }
    loadData()
        {
            
            this.convenio.idPostulacion = this.data.idPostulacion 
            this.convenio.idConvenio= this.data.idConvenio
            this.data.recarga = false
            
            this.data.rol = localStorage.getItem('rol')
            this.convenioService.traeProveedoresPorId(this.data.idProveedor).then (salida => 
                
                this.proveedor = salida).catch(error =>{ console.log(error);  });
           
            this.convenioService.traeRegiones().then(regiones => this.regiones = regiones).catch(error => console.log(error));

        
        }
    onCancelarClick(): void { this.dialogRef.close() }

    onRechazarClick():void {
        let vm = this
        const dialogRef = this.dialog.open(ConfirmationDialog,
            {
                data: { message: '¿Esta seguro de rechazar ser codeudor?', buttonText: { ok: 'Si', cancel: 'No' } }
            })
            dialogRef.afterClosed().subscribe((confirmed: boolean) =>
            {
                if (confirmed){
                    this.data.recarga = true;
                    Swal.fire({
                        allowOutsideClick:false,
                        icon:'info',
                        text:'Cargando...'
                      });
                      Swal.showLoading();
                      console.log("rechazar codeudor");
                    this.convenioService.rechazarSerCodeudor(this.convenio,localStorage.getItem("idUsuario"),false).then
                    (
                        () =>
                        {
                            let vm=this
                         
                            vm.openAlertDialog('Se ha rechazado ser codeudor.', 'btn-success')
                            
                            Swal.close();
                        }
                    )
                    .catch((err) => {
                        vm.openAlertDialog('Ocurrió un al rechazar a ser codeudor.', 'btn-danger')
                    });
                      vm.dialogRef.close()
                     Swal.close();
                }
            })
        }
    
        
    onAceptarClick():void{
        let vm = this
  
    if(!this.convenio.archivos[1]){
        this.openAlertDialog('Debe adjuntar el archivo de Cédula de Identidad (FRONTAL)', 'btn-dark')
        Swal.close();
        this.procesando = false
        return;
    }

    if(!this.convenio.archivos[2]){
        this.openAlertDialog('Debe adjuntar el archivo de Cédula de Identidad (POSTERIOR)', 'btn-dark')
        Swal.close();
        this.procesando = false
        return;
    }

    if(this.convenio.archivoTest != null ){
        const dialogRef = this.dialog.open(ConfirmationDialog,
        {
             width:'600px',
            maxWidth: '95w',
            panelClass: 'confirm-dialog-especial',
            data: { message: '¿Esta seguro de aceptar ser codeudor? Recuerde que, en caso de renuncia, término de contrata o incumplimiento de pago por parte del titular, el saldo del préstamo será descontado de su remuneración. ', buttonText: { ok: 'Si', cancel: 'No' } }
        })
        dialogRef.afterClosed().subscribe((confirmed: boolean) =>
        {
            if (confirmed){
                this.data.recarga = true;
                Swal.fire({
                    allowOutsideClick:false,
                    icon:'info',
                    text:'Cargando...'
                  });
                  Swal.showLoading();
          
            let sizeArchivos = 0;
        
            for (let i = 1; i < this.cantidadArchivos; i++) {
                sizeArchivos += this.convenio.archivos[i].size;
                if (sizeArchivos > 25000000) {
                    this.openAlertDialog('Los archivos no deben sobrepasar 25mb en total', 'btn-dark')
                    Swal.close();
                    this.procesando = false
                    return;
                }
                if (this.convenio.archivos[i].extension != "application/pdf" && this.convenio.archivos[i].extension != "image/jpeg" &&
                    this.convenio.archivos[i].extension != "image/jpg" && this.convenio.archivos[i].extension != "image/png") {
                    this.openAlertDialog('El archivo ' + (i + 1) + ' debe ser de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
                    this.convenio = false
                    Swal.close();
                    return false
                }
            }
            
            this.convenio.idConvenio = this.data.idConvenio;
 

                  this.convenioService.aprobarSerCodeudor(
                  this.convenio,
                    localStorage.getItem("idUsuario"),true).then
                  (
                      () =>
                      {
                          let vm=this
                       
                          vm.openAlertDialog('Se ha aprobado ser codeudor exitosamente.', 'btn-success')
                          
                          Swal.close();
                      }
                  )
                  .catch((err) => {
                      vm.openAlertDialog('Ocurrió un al aprobar ser codeudor.', 'btn-success')
                  });
                    vm.dialogRef.close()
                   Swal.close();
              }
                  vm.dialogRef.close()
                 Swal.close();
            }
         )
    }else{
        vm.openAlertDialog('Debe seleccionar un archivo.', 'btn-danger')
    }
    }
    

    seleccionaArchivo(event: any, numero: number) {
        let vm = this
        if (event.target.files.length > 0) {
        
            let reader = new FileReader()

            reader.readAsDataURL(event.target.files[0])

            reader.onload = function () {
                vm.convenio.archivos[numero] = { url: "", archivo: reader.result, extension: event.target.files[0].type, size: event.target.files[0].size }

               
            }
        }
      
    }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
